import _slicedToArray from "/Users/lacassiano.sugiyama/Workspace/peloton/git/web-tv/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
var __jsx = React.createElement;
import { useRouter } from 'next/router';
import React from 'react';
import { PELOTON_PLATFORM } from '@webtv/env';
import { InternationalizeProvider } from '@webtv/internationalize';
import { FullScreenSpinner } from '@webtv/shared-ui';
import { TermsTakeoverView } from './TermsTakeoverView';
import { shouldSkipTakeoverForPath, usePendingContracts, RequiredActions } from './utils';
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
export var ContractAgreementsTakeover = function ContractAgreementsTakeover(_ref) {
  var children = _ref.children;

  var _React$useState = React.useState(false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      showAckModal = _React$useState2[0],
      setShowAckModal = _React$useState2[1];

  var router = useRouter();

  var _usePendingContracts = usePendingContracts(),
      updatedContractTypes = _usePendingContracts.updatedContractTypes,
      pendingContracts = _usePendingContracts.pendingContracts,
      requiredAction = _usePendingContracts.requiredAction,
      hasLoaded = _usePendingContracts.hasLoaded,
      handleContinue = _usePendingContracts.handleContinue,
      handleLogout = _usePendingContracts.handleLogout;

  React.useEffect(function () {
    // Set initial acknowledge state in React so that the background ack PUT
    // does not automatically close the modal
    if (hasLoaded && requiredAction === RequiredActions.acknowledge && !showAckModal) {
      setShowAckModal(true);
      handleContinue === null || handleContinue === void 0 ? void 0 : handleContinue();
    }
  }, [handleContinue, hasLoaded, requiredAction, showAckModal]);

  if (shouldSkipTakeoverForPath(router)) {
    return /*#__PURE__*/_jsx(_Fragment, {
      children: children
    });
  }

  if (!hasLoaded) {
    return /*#__PURE__*/_jsx(FullScreenSpinner, {});
  }

  if (requiredAction === RequiredActions.acknowledge && showAckModal || pendingContracts.length > 0) {
    return /*#__PURE__*/_jsx(InternationalizeProvider, {
      page: "terms",
      pelotonPlatform: PELOTON_PLATFORM,
      children: /*#__PURE__*/_jsx(TermsTakeoverView, {
        docsToShow: pendingContracts,
        onContinueSelected: function onContinueSelected() {
          if (requiredAction === RequiredActions.acknowledge) {
            setShowAckModal(false);
          } else {
            handleContinue === null || handleContinue === void 0 ? void 0 : handleContinue();
          }
        },
        logout: handleLogout,
        updatedContractTypes: updatedContractTypes,
        requiredAction: requiredAction
      })
    });
  }

  return /*#__PURE__*/_jsx(_Fragment, {
    children: children
  });
};